import { MAT_DATE_RANGE_SELECTION_STRATEGY } from "@angular/material/datepicker";
import { Directive, Inject, Input } from "@angular/core";

import { MaxRangeSelectionStrategy } from "./day-range-selection-strategy.util";

@Directive({
  selector: "[maxPickerRange]",
  standalone: true,
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy
    }
  ]
})
export class MaxRangeDirective {
  constructor(
    @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
    private maxRangeStrategy: MaxRangeSelectionStrategy<any>
  ) {}

  @Input() set maxPickerRange(value: number) {
    this.maxRangeStrategy.delta = +value || 7;
  }
}
